import Vue from "vue";
import { menuTree } from "@/api/menu";

function mergeLeaf(item) {
  if (!item.son) return item;
  return { ...item.itself, children: item.son.map(mergeLeaf) };
}
export default new Vue({
  data() {
    return {
      tree: []
    };
  },
  created() {
    this.initMenu();
  },
  methods: {
    async initMenu() {
      try {
        const { data } = await menuTree();
        this.tree = data;
      } catch (error) {
        this.tree = [];
      }
    },
    createDataL() {
      return this.tree.map(mergeLeaf);
    }
  },
  computed: {
    menuTree() {
      return this.tree.map(mergeLeaf);
    }
  }
});
